import Usuarios from "../htmlRep/reports/Usuarios";
import Archivos from "../htmlRep/reports/Archivos";
import Sentencias from "./reports/Sentencias";


export default function getReportHTML(report: number, openT:boolean){
    switch(report){
        case 1: return <Archivos report={report} openT={openT} />;
        case 2: return <Usuarios report={report} openT={openT} />;
        case 3: return <Sentencias />;
        default: return <h5>El reporte seleccionado no existe</h5>
        //default: throw new Error("El reporte seleccionado no existe", {cause: 404});
    }
}